import { ChangeDetectorRef, EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { ControlValueAccessor, NgControl, } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { identifier } from '@uipath/angular/utilities';
import { Subject } from 'rxjs';
var SimpleMultiChoiceEntryComponent = /** @class */ (function () {
    function SimpleMultiChoiceEntryComponent(_cd) {
        this._cd = _cd;
        this.defaultValue = null;
        this.labelText = 'Value';
        this.disabled = false;
        this.currentValue = null;
        this.shouldLabelFloat = false;
        this.stateChanges = new Subject();
        this.ngControl = null;
        this.focused = false;
        this.errorState = false;
        this.describedBy = '';
        this.optionChange = new EventEmitter();
        this._required = false;
        this._onChange = function (_value) { };
        this._randomName = identifier();
        this.id = 'multi-choice-simple-' + this._randomName;
    }
    Object.defineProperty(SimpleMultiChoiceEntryComponent.prototype, "choices", {
        get: function () {
            return this.possibleValues.map(function (value) { return ({
                id: value,
                text: value,
            }); });
        },
        enumerable: true,
        configurable: true
    });
    SimpleMultiChoiceEntryComponent.prototype.ngOnInit = function () {
        this.currentValue = this.defaultValue;
    };
    SimpleMultiChoiceEntryComponent.prototype.ngOnDestroy = function () {
        this.stateChanges.complete();
    };
    Object.defineProperty(SimpleMultiChoiceEntryComponent.prototype, "value", {
        get: function () {
            return this.currentValue;
        },
        set: function (state) {
            this.currentValue = state;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SimpleMultiChoiceEntryComponent.prototype, "placeholder", {
        get: function () {
            return this.labelText;
        },
        set: function (plh) {
            this.labelText = plh;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SimpleMultiChoiceEntryComponent.prototype, "empty", {
        get: function () {
            return this.currentValue == null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SimpleMultiChoiceEntryComponent.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (req) {
            this._required = req;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    SimpleMultiChoiceEntryComponent.prototype.writeValue = function (value) {
        this.currentValue = value;
        this._cd.markForCheck();
        this.stateChanges.next();
    };
    SimpleMultiChoiceEntryComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    SimpleMultiChoiceEntryComponent.prototype.registerOnTouched = function (_) { };
    SimpleMultiChoiceEntryComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this._cd.detectChanges();
    };
    SimpleMultiChoiceEntryComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    SimpleMultiChoiceEntryComponent.prototype.onContainerClick = function (_event) { };
    SimpleMultiChoiceEntryComponent.prototype.onChoiceSelect = function (choice) {
        var choiceValueAsString = choice ? choice.id : null;
        this.writeValue(choiceValueAsString);
        this._onChange(choiceValueAsString);
        this.optionChange.emit(choiceValueAsString);
    };
    return SimpleMultiChoiceEntryComponent;
}());
export { SimpleMultiChoiceEntryComponent };
